import React from 'react';
import StaticPageLayout from '../layouts/StaticPageLayout';
import PrivacyPolicyContent from '../shared/content/PrivacyPolicyContent';

const PrivacyPolicy = () => {
    return (
        <StaticPageLayout>
            {/* Hero Section with Gradient */}
            <div className="relative overflow-hidden" style={{ 
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                minHeight: '350px' 
            }}>
                <div className="absolute w-full h-full opacity-10">
                    <div className="absolute" style={{ 
                        top: '-5%', 
                        left: '80%',
                        width: '250px',
                        height: '250px',
                        borderRadius: '50%',
                        background: 'white'
                    }}></div>
                </div>
                
                <div className="relative z-1 px-4 py-6 md:py-8 lg:px-8 text-center text-white">
                    <i className="pi pi-shield text-4xl md:text-6xl mb-3 md:mb-4 opacity-90"></i>
                    <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold mb-3 md:mb-4">Privacy Policy</h1>
                    <p className="text-base md:text-lg lg:text-xl opacity-80 px-4" style={{ maxWidth: '800px', margin: '0 auto' }}>
                        Your privacy is important to us. This policy outlines how we protect your information.
                    </p>
                </div>
            </div>

            {/* Main Content */}
            <div className="px-4 lg:px-8 py-8">
                <div className="max-w-7xl mx-auto">
                    <div style={{ marginTop: '-5rem' }} className="relative z-2">
                        <PrivacyPolicyContent showHeroCards={true} />
                    </div>
                </div>
            </div>
        </StaticPageLayout>
    );
};

export default PrivacyPolicy;